export const INVALID_MACHINE_GUID = -102;
export const SESSION_ID_TERMINAL_ID_MISMATCH = -118;
export const USER_SESSION_IS_EMPTY = -119;



// WEBPACK FOOTER //
// ./src/HOCs/Constants/DatabaseErrorCodes.js